import React, {useState} from "react";
import PropTypes from "prop-types";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

// Utils
import useApi from "../../hooks/useApi.js";

// Components
import Modal from "../../components/Modal.js";
import {InputText} from "../../components/form/FormInputs.js";

// Style
import {breakpoint} from "../../style/components/breakpoints.js";
import {
  Button,
  ButtonLoader,
  Form,
  FormField,
  FormGroup,
  HeadingCenter
} from "../../style/components/general.js";

const schema = yup.object().shape({
  name: yup.string().trim().required("Please provide name.")
});

const ModalRegion = ({visible, setVisible, region, update}) => {
  const [saving, setSaving] = useState(false);

  // Errors are shown on the name field instead of as a toast
  const {api} = useApi("regions", {suppress: {error: true}});

  const form = useForm({
    defaultValues: {name: (region?.name ?? "").toUpperCase()},
    resolver: yupResolver(schema)
  });
  const {handleSubmit, setError} = form;

  const saveRegion = ({name}) => {
    setSaving(true);
    const request = region ? api.callPut(region.id, {name}) : api.callPost({name});

    request.then(response => {
      setSaving(false);
      if (response?.status === 200 || response?.status === 201) {
        update();
        setVisible(false);
      } else if (typeof response === "string") {
        setError("name", {type: "server", message: response});
      }
    });
  };

  return (
    <Modal visible={visible} setVisible={setVisible} width={breakpoint.width[1]}>
      <HeadingCenter>{region ? "Edit Region" : "Add Region"}</HeadingCenter>
      <FormProvider {...form}>
        <Form onSubmit={handleSubmit(saveRegion)} noValidate>
          <FormGroup>
            <FormField>
              <InputText name="name" label="Name" placeholder="Name..." required />
            </FormField>
          </FormGroup>
          <Button type="submit" loading={saving ? 1 : 0}>
            {saving && <ButtonLoader />}
            Save
          </Button>
        </Form>
      </FormProvider>
    </Modal>
  );
};

ModalRegion.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  region: PropTypes.objectOf(PropTypes.any),
  update: PropTypes.func.isRequired
};

export default ModalRegion;
